<template>
  <!--导入房间-->
  <div class="advanced-form">
    <div class="card">
      <div class="card-head">
        <h3>导入说明</h3>
      </div>
      <div class="card-body">
        <p :style="{lineHeight: '25px'}">
          请先创建单元数据，导入文件中从左到右依次为：房间编号，建筑面积<br>导入数据从第二行开始
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>下载模板，填写数据</h3>
      </div>
      <div class="card-body">
        <a-button @click="downTemplate" type="primary" :disable="disableDown">下载模板</a-button>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>选择要导入的小区楼栋，设置选项后上传</h3>
      </div>
      <div class="card-body">
        <x-addEdit
          ref="addEdit"
          :style="{width: '500px'}"
          :itemLayout="itemLayout"
          :formList="formList"
          :addParam="addParam"
          :editParam="editParam"
          :detailParam="detailParam"
        >
        </x-addEdit>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
// import axios from 'axios';
export default {
  mixins: [fetchSelect],
  name: 'importRoom',
  data () {
    const decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      buildingId: {
        rules: [{ required: true, message: '请选择所属楼栋' }]
      },
      unitId: {
        rules: [{ required: true, message: '请选择所属单元' }]
      },
      file: {
        rules: [{ required: true, message: '请选择房间数据' }]
      }
    };
    return {
      roomData: {},
      downloadUrl: '',
      disableDown: false,
      itemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择小区',
          handle: (e) => {
            this.$refs.addEdit.resetSubValue(['buildingId', 'unitId'], e);
            this.communityChange(1, e, 'formList');
          },
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          placeholder: '请选择楼栋',
          handle: (e) => {
            this.buildingChange(2, e, 'formList');
            this.$refs.addEdit.resetSubValue(['unitId'], e);
          },
          props: ['buildingId', decoratorOptions.buildingId]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unitId', decoratorOptions.unitId]
        },
        {
          label: '房间数据',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/upload/normalFile',

            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.excelAccept
          },
          beforeHandle: this.beforeHandle,
          props: ['file', decoratorOptions.file]
        }
      ],
      addParam: {
        url: '/room/import',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      editParam: {},
      detailParam: {}
    };
  },
  created () {
    this.btnAuth();
    // this.communitySelect(0, 'formList', 1);
    this.communitySelectByStep(1, undefined, undefined, '0');
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, undefined, '0');
    },
    testMessage () {
      let content = '这是第一行<br> 这是第二行<br> 这是第三行<br> 这是第四行，这是第五行';

      this.$message.error(h => h({
        template: `
        <div> ${content} </div>`
      }));
    },
    /** 自定义房间数据 upload */
    beforeHandle (file, fileList) {
      this.roomData = file;
      const index = this.formList.findIndex(item => item.props && item.props[0] === 'file');
      this.formList[index].fileList = [{
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file)
      }];

      return false;
    },
    downTemplate () {
      window.open(process.env.VUE_APP_BASE_API + '/room/download');
    },
    btnAuth () {
      const btnList = this.getLocal('btnList');
      btnList && btnList.forEach((el) => {
        if (this.$route.name === el.componentName) {
          el.key === 'download' && (this.disableDown = false);
        }
      });
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      const formdata = new FormData();
      for (const item in param) {
        item !== 'file' && formdata.set(item, param[item]);
      }
      formdata.set('file', this.roomData);
      return formdata;
    },
    addResHandle (res) {
      const codeType = { 200: 'success', 500: 'warn' };
      this.$message[codeType[res.code]](h => h({
        template: `
        <div>${res.msg}</div>`
      }));
      this.$store.dispatch('delCachedRoute', 'importRoom');
      this.$router.go(-1);
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
